const parametro = {
  readParametroCotizacion: 'parametros/cotizacion/{{id_plan}}',
  readParametroDocumentoTipos: 'parametros/documento_tipos/{{id_pais}}',
  readParametroPaises: 'parametros/paises',
  readParametroProvincias: 'parametros/provincias/{{id_pais}}',
  readAutorizadoresFiscales: 'autorizadores-fiscales',
  readAutorizadoresConfigurados: 'autorizadores-fiscales/configurados/{{id_academia}}',
  readAutorizadoresParametros: 'autorizadores-fiscales/{{id_autorizador}}/parametros/{{id_academia}}',
  readAutorizadorConfiguraciones: 'autorizadores-fiscales/{{id_autorizador}}/configurar/{{id_academia}}',
  createAcademiaAutorizador: 'autorizadores-fiscales/{{id_autorizador}}/crear/{{id_academia}}',
  asociateAutorizadorFiscalAcademia: 'autorizadores-fiscales/{{autorizador_fiscal}}/asociar/{{id_academia}}'
}

export default parametro
